import { TableCard } from 'app/components'
import { ModelosListHeader } from './components/header/ModelosListHeader'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { ModelosTable } from './table/ModelosTable'

const ModelosList = () => {
  return (
    <TableCard>
      <ModelosListHeader />
      <ModelosTable />
    </TableCard>
  )
}

export const ModelosListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListFiltersProvider>
        <ModelosList />
      </ListFiltersProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
